import { Input } from '../../Input/Input'
import { FromToRangeModalProps } from './FromToRangeModal'

export const FromToRangeModalInputFrom = (props: FromToRangeModalProps): JSX.Element => {
  return (
    <Input
      type={props.inputType}
      error={!!props.errors?.from}
      disabled={!props.onFromChange}
      value={props.fromValue}
      onChange={(e) => props.onFromChange && props.onFromChange(e.target.value)}
      placeholder={props.labels?.from}
      endIcon={props.icon}
    />
  )
}

export const FromToRangeModalInputTo = (props: FromToRangeModalProps): JSX.Element => {
  return (
    <Input
      type={props.inputType}
      error={!!props.errors?.to}
      disabled={!props.onToChange}
      value={props.toValue}
      onChange={(e) => props.onToChange && props.onToChange(e.target.value)}
      placeholder={props.labels?.to}
      endIcon={props.icon}
    />
  )
}
